<template>
  <form action="#" class="c-account-form">
    <h2 class="c-account-form__title t-head t-head--main"><strong>Załóż konto</strong></h2>
    <div class="c-account-form__cols">
        <div class="c-account-form__col u-hidden@m">
          <div class="c-welcome-box">
            <h3 class="t-head t-head--default">Dlaczego warto?</h3>

            <ul class="t-list t-list--icons t-list--primary">
              <li class="t-list__item">
                <span class="o-ico">
                  <img src="../../assets/images/ico-why-1.svg" alt="Ekspresowa wysyłka" />
                </span>
                <strong>Ekspresowa wysyłka</strong>
              </li>
              <li class="t-list__item">
                <span class="o-ico">
                  <img src="../../assets/images/ico-why-2.svg" alt="Darmowa dostawa" />
                </span>
                <strong>Darmowa dostawa</strong>
              </li>
              <li class="t-list__item">
                <span class="o-ico">
                  <img src="../../assets/images/ico-why-3.svg" alt="Gwarancja Triny" />
                </span>
                <strong>Gwarancja Triny</strong>
              </li>
              <li class="t-list__item">
                <span class="o-ico">
                  <img src="../../assets/images/ico-why-4.svg" alt="Bezpieczne płatnosci" />
                </span>
                <strong>Bezpieczne płatności</strong>
              </li>
            </ul>
          </div>
        </div>
        <div class="c-account-form__col">
          <loading-indicator :isLoading="isProcessing" loadingText="Trwa rejestracja..."></loading-indicator>
          <p class="f-message is-error" v-html="errors.global" v-if="errors.global">{{ errors.global }}</p>

          <div class="l-grid-wrapper">
            <div class="l-grid u-space-h-2 u-space-h-1@m u-space-v-4 u-space-v-2@m">
              <div class="l-grid__item l-grid__item-6">
                <div class="f-field">
                  <input v-model="name" type="text" value="" placeholder="Imię" class="f-control f-control--text f-control--default f-control--theme-2 f-control--sh-3" v-bind:class="{ 'is-error': errors.name }" />
                  <p class="f-message is-error" v-if="errors.name">{{ errors.name }}</p>
                </div>
              </div>
              <div class="l-grid__item l-grid__item-6">
                <div class="f-field">
                  <input v-model="lastname" type="text" value="" placeholder="Nazwisko" class="f-control f-control--text f-control--default f-control--theme-2 f-control--sh-3" v-bind:class="{ 'is-error': errors.lastname }" />
                  <p class="f-message is-error" v-if="errors.lastname">{{ errors.lastname }}</p>
                </div>
              </div>
              <div class="l-grid__item l-grid__item-6">
                <div class="f-field">
                  <input v-model="email" type="text" value="" placeholder="Adres e-mail" class="f-control f-control--text f-control--default f-control--theme-2 f-control--sh-3" v-bind:class="{ 'is-error': errors.email }" />
                  <p class="f-message is-error" v-if="errors.email">{{ errors.email }}</p>
                </div>
              </div>
              <div class="l-grid__item l-grid__item-6">
                <div class="f-field">
                  <input v-model="password" type="password" value="" placeholder="Hasło (co najmniej 5 znaków)*" class="f-control f-control--text f-control--default f-control--theme-2 f-control--sh-3" v-bind:class="{ 'is-error': errors.password }" />
                  <p class="f-message is-error" v-if="errors.password">{{ errors.password }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="f-field">
            <label for="label-1" class="f-control f-control--choose f-control--choose--alt">
              <input type="checkbox" name="newsletter" id="label-1" />
              <span class="f-control__indicator"></span>
              <span class="f-control__label">Zamawiam newsletter z informacjami o rabatach, dostawie GRATIS, innych promocjach, konkursach oraz nowościach! Wyrażam zgodę na otrzymywanie informacji handlowych drogą elektroniczną od Triny Sp. z o. o.</span>
            </label>
          </div>

          <div class="f-field">
            <label for="label-2" class="f-control f-control--choose f-control--choose--alt" v-bind:class="{ 'is-error': errors.accept }">
              <input v-model="accept" type="checkbox" name="accept" id="label-2" />
              <span class="f-control__indicator"></span>
              <span class="f-control__label"><span class="u-paint-red-1">*</span> Akceptuję <a href="/content/3-regulamin-sklepu" target="_blank">Regulamin</a> oraz <a href="/content/2-polityka-prywatnosci" target="_blank">Politykę prywatności</a>.</span>
            </label>
            <p class="f-message is-error" v-if="errors.accept">{{ errors.accept }}</p>
          </div>

          <ul class="c-actions-list">
            <li class="c-actions-list__item u-grow c-action-list__item-withfb">
              <button type="submit" class="c-btn c-btn--primary c-btn--full c-btn--theme-1 c-btn--border-radius-full" @click.prevent="sendRegister">
                Zarejestruj się
              </button>
            </li>
            <li class="c-actions-list__item u-grow c-action-list__item-withfb loginfb">
              <div id="fb-root"></div>
              <a @click.prevent="loginFb" class="c-btn c-btn--primary c-btn--full c-btn--facebook c-btn--border-radius-full">
                <span class="hisc-button-icon">
                  <svg width="30" height="30" enable-background="new 0 0 408.788 408.788" version="1.1" viewBox="0 0 408.788 408.788" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                    <path d="m353.7 0h-298.61c-30.422 0-55.085 24.662-55.085 55.085v298.62c0 30.423 24.662 55.085 55.085 55.085h147.28l0.251-146.08h-37.951c-4.932 0-8.935-3.988-8.954-8.92l-0.182-47.087c-0.019-4.959 3.996-8.989 8.955-8.989h37.882v-45.498c0-52.8 32.247-81.55 79.348-81.55h38.65c4.945 0 8.955 4.009 8.955 8.955v39.704c0 4.944-4.007 8.952-8.95 8.955l-23.719 0.011c-25.615 0-30.575 12.172-30.575 30.035v39.389h56.285c5.363 0 9.524 4.683 8.892 10.009l-5.581 47.087c-0.534 4.506-4.355 7.901-8.892 7.901h-50.453l-0.251 146.08h87.631c30.422 0 55.084-24.662 55.084-55.084v-298.62c-1e-3 -30.423-24.663-55.085-55.086-55.085z" fill="#fff"/>
                  </svg>
                </span>
                <span class="hisc-button-text">
                  <span class="hisc-button-text_main">Rejestracja z FB</span>
                  <span class="hisc-button-text_small">Bez udostępniania na Twoim FB!</span>
                </span>
              </a>
            </li>
          </ul>
        </div>
    </div>
    <div class="c-account-form__foot c-message c-message--default u-text-center">
      <strong>Już masz konto?</strong> <a href="" @click="$emit('modal-open', $event)"><strong>Zaloguj się →</strong></a>
    </div>
  </form>
</template>

<script>
import {getRegister} from '@/api/auth'
import LoadingIndicator from '@/components/LoadingIndicator'

export default {
  components: {
    LoadingIndicator
  },

  data () {
    return {
      email: '',
      password: '',
      name: '',
      lastname: '',
      accept: '',
      errors: [],
      isProcessing: false
    }
  },

  methods: {
    sendRegister () {
      if (this.validate()) {
        const self = this
        self.setIsProcessing(true)

        getRegister(this.email, this.password, this.name, this.lastname)
          .then(result => {
            self.setIsProcessing(false)
            if (result.hasError) {
              self.setGlobalError(result.errors[0])
            } else {
              self.$emit('modal-close')
              window.location.reload(true)
            }
          })
          // .catch(() => {
          //   self.setIsProcessing(false)
          //   self.setGlobalError('Nie udało się zalogować. Spróbuj ponownie.')
          // })
      }
    },

    loginFb () {
      if (this.validateFb()) {
        // eslint-disable-next-line no-undef
        fb_login()
      }
    },

    validate () {
      this.errors = {}

      this.validateBody()

      return Object.keys(this.errors).length === 0
    },

    validateFb () {
      this.errors = {}

      this.validateBodyFb()

      return Object.keys(this.errors).length === 0
    },

    validateBody () {
      if (!this.name) {
        this.errors['name'] = 'Imię jest wymagane'
      }

      if (!this.lastname) {
        this.errors['lastname'] = 'Nazwisko jest wymagane'
      }

      if (!this.email) {
        this.errors['email'] = 'E-mail jest wymagany'
      }

      if (!this.password) {
        this.errors['password'] = 'Hasło jest wymagane'
      }

      if (!this.accept) {
        this.errors['accept'] = 'Proszę zaakceptować regulamin'
      }
    },

    validateBodyFb () {
      if (!this.accept) {
        this.errors['accept'] = 'Proszę zaakceptować regulamin'
      }
    },

    setGlobalError (error) {
      this.errors = {global: error}
    },

    setIsProcessing (isProcessing) {
      this.isProcessing = isProcessing
      // EventBus.$emit(GlobalEvents.reviews_processingChanged, {isProcessing})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserAuth/UserAuthModalRegister.vue